import React from "react";
import { styled } from "@mui/material/styles";
import { Switch, FormControlLabel, Box } from "@mui/material";

// Custom styled switch
const RedSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  margin: 0,
  "& .MuiSwitch-switchBase": {
    padding: 1,

    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#FC0108",
      "& + .MuiSwitch-track": {
        backgroundColor: "#ffe5e5",
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#ffe5e5",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const CustomToggle = ({ label, checked, onChange }) => {
  return (
    <Box
      sx={{ border: "1px solid black", width: "100%", padding: "12px 10px" }}
    >
      <FormControlLabel
        label={label}
        labelPlacement="start" // ✅ Label on left
        sx={{
          display: "flex",
          justifyContent: "space-between",
          margin: 0,
        }} // ✅ Optional spacing
        control={
          <RedSwitch
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
        }
      />
    </Box>
  );
};

export default CustomToggle;
